var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TitledNumericalInputField',{attrs:{"inputLabel":"Fouling","iconName":"mdi-grass","value":+_vm.efficiency.toFixed(2),"rules":[function (value) { return value >= 0 || 'Value must be positive'; }],"onChange":_vm.handleInputChange}})}
var staticRenderFns = []

export { render, staticRenderFns }